import {
  DeltaEstimatedTimeType,
  Nullable,
} from '@project44-models/shipment-list';

const UNITS_DICT = {
  days: 'common.dayWithCount',
  hours: 'common.hourWithCount',
  mins: 'common.minuteWithCount',
};

const MAX_NUM_OF_UNITS = 2;

// { days: 4, hours: 5, minutes: 15 } -> [[4, common.days], [5, common.hours]]
export function getSplitMsg(
  deltaTime: DeltaEstimatedTimeType,
): [number, string][] {
  const result = Object.entries(deltaTime).map(([units, value]) => {
    const dictUnits = UNITS_DICT[units as keyof DeltaEstimatedTimeType];
    return [Math.abs(value), dictUnits];
  });

  return result.filter((item) => item[0] !== 0).slice(0, MAX_NUM_OF_UNITS) as [
    number,
    string,
  ][];
}

function isArrivalLate(deltaTime: DeltaEstimatedTimeType) {
  return Object.values(deltaTime).some((value) => value > 0);
}

export const getMetadata = (
  deltaTime?: Nullable<DeltaEstimatedTimeType>,
  isEstimate?: boolean,
) => {
  if (!deltaTime) {
    return { title: '', description: '', color: '', msg: [] };
  }

  const msg = getSplitMsg(deltaTime);
  const isLate = isArrivalLate(deltaTime);
  const arrived = isLate
    ? 'common.arrivedLateByTime'
    : 'common.arrivedEarlyByTime';
  const estimated = isLate
    ? 'common.estimatedLateByTime'
    : 'common.estimatedEarlyByTime';

  if (!msg.length) {
    return {
      title: 'common.onTime',
      description: 'common.arrivingOnTime',
      color: '$palette-indigo-500',
      msg,
    };
  }

  return {
    title: isLate ? 'common.plusMessage' : 'common.minusMessage',
    description: isEstimate ? estimated : arrived,
    color: isLate ? '$palette-red-600' : '$palette-purple-700',
    msg,
  };
};
